import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CategoryWiseReportsContent from '../CategoryWiseReportsContent';
import {
    setFromDate,
    setToDate,
    setSelectedBranch,
    fetchCategoryFullReport
} from '../../../store/slices/categoryWiseReportsSlice';

const CategoryWiseReports = () => {
    const dispatch = useDispatch();
    const storedBranchId = localStorage.getItem('branchid') || '';
    const storedBranchName = localStorage.getItem('branchname') || 'Current Branch';

    useEffect(() => {
        const today = new Date();
        dispatch(setFromDate(today));
        dispatch(setToDate(today));
        dispatch(setSelectedBranch({ branch_id: storedBranchId, branch_name: storedBranchName }));
        dispatch(fetchCategoryFullReport({
            fromDate: today,
            toDate: today,
            branchId: storedBranchId
        }));
    }, [dispatch, storedBranchId, storedBranchName]);

    return <CategoryWiseReportsContent isManagerView />;
};

export default CategoryWiseReports;

